import { render, staticRenderFns } from "./AddressManage.vue?vue&type=template&id=108a04fd&scoped=true"
import script from "./AddressManage.vue?vue&type=script&lang=js"
export * from "./AddressManage.vue?vue&type=script&lang=js"
import style0 from "./AddressManage.vue?vue&type=style&index=0&id=108a04fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a04fd",
  null
  
)

export default component.exports